
<div v-if="showBadges" class="admin-card-badges">
  <badge v-if="statusLabel" icon="assignment" :label="statusLabel" />
  <badge v-if="card.needsReview" icon="assignment" label="Needs Review" />
</div>
